import React, { Suspense, lazy } from 'react';

const loadGamificationModule = () => import('./GamificationModule');

const LazyGamificationModule = lazy(loadGamificationModule);

export const preloadGamificationModule = () => loadGamificationModule();

const GamificationModuleDeferred = (props) => (
  <Suspense fallback={<div className="text-sm text-muted-foreground">Loading Engagement & Rewards...</div>}>
    <LazyGamificationModule {...props} />
  </Suspense>
);

export default GamificationModuleDeferred;
